import { Expose, Type } from "class-transformer";

export default class MessageBoardCheckRes {
  @Expose() readonly messageBoardCheckId!: number;
  @Expose() readonly messageBoardId!: number;
  @Expose() readonly companyId!: number;
  @Expose() readonly staffId!: number;
  @Type(() => Date)
  @Expose()
  readonly createdAt!: Date;
}
